module.exports = __webpack_public_path__ + "static/img/product01-1.9e8c6b4f.png";